<template>
  <FForm
    v-model="value"
    route="blog-posts"
    title="Blog"
    columns="2"
    :submit="submit"
    :schema="[
      {
        component: 'FInput',
        key: 'title',
        label: 'Title',
        column: 1
        // {
        //   component: 'FInput',
        //   key: 'subtitle',
        //   label: 'Subtitle',
        //   column: 1
        // }
      },
      //[
        {
          component: 'FInput',
          key: 'slug',
          label: 'Slug',
          column: 1
        },
          // {
          //   component: 'FInput',
          //   key: 'section',
          //   label: 'Section',
          //   column: 1
          // }
      //],
      {
        component: 'FEditor',
        key: 'content',
        label: 'Content',
        column: 1
      },
      // {
      //   component: 'FEditor',
      //   key: 'ksp_content',
      //   label: 'KSP Content',
      //   column: 1
      // },
      // {
      //   component: 'FInput',
      //   key: 'ksp_bg_hex',
      //   label: 'KSP Panel Background Colour (Hex)',
      //   column: 1
      // },
      // [
      //   {
      //     component: 'FInput',
      //     key: 'ksp_button_title',
      //     label: 'KSP Button Title',
      //     column: 1
      //   },
      //   {
      //     component: 'FInput',
      //     key: 'ksp_button_url',
      //     label: 'KSP Button URL',
      //     column: 1
      //   }
      // ],
      {
        component: 'FEditor',
        key: 'overview',
        label: 'Overview',
        column: 1
      },
      {
        component: 'FCheckboxList',
        key: 'related_tours',
        label: 'Related Tours',
        items: tours,
        column: 1,
      },
      // {
      //   component: 'FSelect',
      //   key: 'destination_id',
      //   label: 'Destination',
      //   items: destinations,
      //   column: 1,
      // },
      {
        component: 'FSelect',
        default: this.showOnHomepageDefault,
        // default: this.value?.show_on_homepage !== undefined ? this.value.show_on_homepage : true,
        key: 'show_on_homepage',
        label: 'Visible on homepage?',
        items: [
          {
            id: null,
            // value: value.show_on_homepage === true ? value.show_on_homepage : '',
            // value: value?.show_on_homepage == null ? null : value?.show_on_homepage,
            name: '-- select --'
          },
          {
            id: true,
            // value: value?.show_on_homepage === true ? true : value?.show_on_homepage,
            name: 'Yes'
          },
          {
            id: false,
            // value: value?.show_on_homepage !== true ? false : value?.show_on_homepage,
            name: 'No'
          }
        ],
        column: 2,
      },
      // {
      //   component: 'FMediaPicker',
      //   key: 'media_id',
      //   label: 'Featured Image',
      //   column: 2,
      // },
      {
        component: 'FMediaPicker',
        key: 'banner_id',
        label: 'Banner',
        column: 2,
      },
      {
        component: 'FMediaPicker',
        key: 'overview_image_id',
        label: 'Overview Image',
        column: 2,
      },
      {
        component: 'FInput',
        key: 'seo_title',
        label: 'SEO Title (max 80 chars)',
        column: 1
      },
      {
        component: 'FTextarea',
        key: 'seo_description',
        label: 'SEO Description (max 150 chars)',
        column: 1
      },
      {
        component: 'FInput',
        key: 'seo_keywords',
        label: 'SEO Keywords (max 5 sentense/words, separated by comma)',
        column: 1
      },

    ]"
  />
</template>

<script>
import FForm from '@/components/FForm'
export default {
  props: {
    value: Object
  },
  mounted () {
    console.log(this.$props)
    if (this.value && this.value.show_on_homepage === undefined) {
      this.$set(this.value, 'show_on_homepage', true)
    }
    console.log(this)
  },
  data () {
    return {
      tours: [],
      destinations: [],
      showOnHomepageDefault: this.value && this.value.show_on_homepage !== undefined ? this.value.show_on_homepage : true,
      styles: [
        {
          id: '',
          name: 'Default'
        }, {
          id: 'minimal',
          name: 'Minimal'
        }
      ]
    }
  },

  components: {
    FForm
  },

  created () {
    this.axios.get('tours/all')
      .then(res => {
        this.tours = res.data
      })

    this.axios.get('destinations')
      .then(res => {
        this.destinations = res.data
        this.destinations.unshift({
          id: 0,
          name: 'None'
        })
      })
  },

  methods: {
    submit (e, {
      method,
      endpoint,
      value,
      redirect,
      route
    }) {
      event.preventDefault()

      if (value.related_tours && value.related_tours.length) {
        value.related_tours = value.related_tours.map(t => t.id)
      }
      console.log(redirect)
      console.log(route)
      delete value['meta']
      delete value['related']
      delete value['image']
      delete value['overview_image']
      delete value['banner']
      delete value['destination']
      delete value['region']
      delete value['blocks']

      console.log(value)

      this.axios[method](endpoint, value)
        .then(() => {
          this.$toasted.success('Saved')
          this.$router.push({ name: redirect || 'blogs' || route })
        })
        .catch(e => this.$store.dispatch('error', e.response.data.error))
    }
  }
}
</script>
